import { render } from "./MenuMobile.vue?vue&type=template&id=1c4424f2&scoped=true&ts=true"
import script from "./MenuMobile.vue?vue&type=script&lang=ts"
export * from "./MenuMobile.vue?vue&type=script&lang=ts"

import "./MenuMobile.vue?vue&type=style&index=0&id=1c4424f2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4424f2"]])

export default __exports__